import accounting from 'accounting';

accounting.settings.currency.precision = 0;
accounting.settings.currency.format = {
  pos: '%s %v',
  zero: '',
};
export default accounting;



// WEBPACK FOOTER //
// ./src/misc/accounting.js